import './App.css';
import ConnectWallet from './components/ConnectWallet';
function App() {
  return (
    <div className="App">
      <ConnectWallet></ConnectWallet>
    </div>
  );
}

export default App;
